import React from "react";
import "./Scientific.css"; 

// Import images for the Scientific Committee
import fellahiImg from "../images/scientific/fellahi.jpg";
import charifaImg from "../images/scientific/charifa.jpeg";
import tliguiImg from "../images/permanent_com/tligi.webp";
import ouafaaImg from "../images/scientific/ouafaa.png";
import pyanaImg from "../images/scientific/pyana.jpg";
import ghanemImg from "../images/permanent_com/ghanem.png";
import yalaceimg from "../images/executive/yalace_kaboret.jpg";
import Annaimg from "../images/executive/Anna_Marais.jpg";
import johnimg from "../images/executive/john_mande.jpeg";
import Olefunkeimg from "../images/executive/Olefunke_Ola_Davies.jpeg";
import alaster from "../images/executive/alaster.jpeg";
import Holm from "../images/executive/Holm.jpeg";
import Ikhlass from "../images/executive/Ikhlass.jpeg";







const Scientific = () => {
  const scientificMembers = [
    {
      name: "Dr. Siham Fellahi",
      title: "IAV Hassan II, Morocco",
      description: "Laboratory Director and Head of the Avian Pathology Unit at IAV Hassan II. Holding a PhD in Veterinary Pathology, she specializes in poultry health, developing new protection strategies, and diagnostic tools for avian viral diseases.",
      image: fellahiImg,
    },
    {
      name: "Dr. Noursaid Tligui",
      title: "IAV HASSAN II , EM6MV-UM6SS, MOROCCO",
      description: "Deputy Director of Academic Affairs at IAV Hassan II with a PhD in Veterinary Pathology from the University of Minnesota. Vice-President of 2A2E-V and Regional Associate for the Council on International Veterinary Medical Education (CIVME) for the MENA region.",
      image: tliguiImg,
    },
    {
      name: "Dr. Charifa Drissi Touzani",
      title: "IAV Hassan II, Morocco",
      description: "Assistant Professor and Head of the Veterinary Histology and Pathology Unit at the Institute of Agronomy and Veterinary Medicine Hassan II (IAV Hassan II), Rabat, Morocco. Her research focuses on diseases affecting domestic and wild animals, and avian pathology, with particular interest in veterinary pathology and One Health sciences.",
      image: charifaImg,
    },
    {
      name: "Dr. Ouafaa Fassi Fihri",
      title: "IAV Hassan II, Morocco",
      description: "Director of the Veterinary Medicine Program at IAV Hassan II. Expertise in virology, immunology, and viral infectious diseases.",
      image: ouafaaImg,
    },
    {
      name: "Dr. PYANA PATI Patient",
      title: "Institut National de Recherche Biomédicale (INRB)",
      description: "Veterinarian and parasitology PhD specializing in tropical medicine, and Treasurer of 2A2E-V.",
      image: pyanaImg,
    },
    { name: "Dr. Alaster Samkange",     title: "University of Namibia, School of Veterinary Medicine,", description: "Clinical Associate Professor, School of Veterinary Medicine, University of Namibia", image: alaster },
    {
          name: "Dr. Mohamed Ghanem",
          title: "Member for North Africa · Benha University, Egypt",
          description: "Member for North Africa",
          image: ghanemImg,
        },
        {
          name: "Dr. Yalace Kaboret",
          title: "2nd Vice President · EISMV, Dakar, Senegal",
          description: "2nd Vice President",
          image: yalaceimg,
        },
        {
          name: "Dr. Anna Marais",
          title: "Member for Southern Africa · University of Namibia",
          description: "Member for Southern Africa",
          image: Annaimg,
        },
    {
          name: "Dr. John Demesei Mande",
          title: "1st Vice President · University of Nairobi, Kenya",
          description: "1st Vice President",
          image: johnimg,
        },
    { name: "Dr. Dietmar Holm",         title: "Professor of bovine herd health", description: "Professor of bovine herd health, University of Pretoria", image: Holm },
    {
          name: "Dr. Olufunke Ola-Davies",
          title: "Member for West Africa · University of Ibadan, Nigeria",
          description: "Member for West Africa",
          image: Olefunkeimg,
        },
    { name: "Dr. El Berbri Ikhlass",    title: "IAV Hassan II, Morocco", description: "currently holds an Associate Professor position at the Veterinary Pathology and Public Health Department, at the Agronomy and Veterinary Hassan II Institute, in Morocco. Her research interests are primarily focused on the One Health Concept and the prevention and control of emerging zoonotic diseases.", image: Ikhlass},
  ];

  return (
    <div className="scientific-section">
      <h1 className="scientific-title">Scientific Committee</h1>
      <div className="scientific-container">
        {scientificMembers.map((member, index) => (
          <div key={index} className="scientific-card">
            <div
              className="scientific-image"
              style={{ backgroundImage: `url(${member.image})` }}
            >
              {member.description && (
                <div className="scientific-hover">
                  <p>{member.description}</p>
                </div>
              )}
            </div>
            <h3 className="scientific-name">{member.name}</h3>
            <p className="scientific-title-small">{member.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Scientific;
